import { Award, CalendarClock, Settings } from "lucide-react";
import type { NavItem, NavSection } from "./navigation";

export const FLEXXI_NAV_ITEMS: NavItem[] = [
  {
    to: "/flexxi/templates",
    label: "Templates",
    icon: CalendarClock,
    perm: "flexxi.read",
    module: "instalments",
  },
  {
    to: "/flexxi/plans",
    label: "Contracts",
    icon: CalendarClock,
    perm: "flexxi.read",
    module: "instalments",
  },
  {
    to: "/flexxi/reputation",
    label: "Reputation",
    icon: Award,
    perm: "flexxi.read",
    module: "instalments",
  },
  {
    to: "/flexxi/settings",
    label: "Settings",
    icon: Settings,
    perm: "settings.read",
    module: "instalments",
  },
];

export const FLEXXI_NAV_SECTIONS: NavSection[] = [{ items: FLEXXI_NAV_ITEMS }];

export const FLEXXI_MODULE_ENTRY: NavItem = {
  to: "/flexxi",
  label: "FlexxiPlan",
  icon: CalendarClock,
  module: "instalments",
  keywords: ["flexxi", "instalment", "plan", "contract", "deposit"],
};
